import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Clipboard } from '../../assets/components/svgs';
import Card from '../shared/cards/Card';
import InputField from '../shared/Fields/InputField';
import { AppConstants } from '../../constants/AppConstants';
import PickList, { PICKLIST_TYPES } from '../shared/Fields/PickList';
import TextAreaField from '../shared/Fields/TextAreaField';
import { getEncounterListItems } from './carePlanUtils';
import JSONEditor from '../AppSettings/JSONEditor';
import { ChildFormProps } from './CarePlanTemplate';
import { findIndex } from 'lodash';

const CarePlanDetails = ({
  isEdit,
  formData,
  setFormData,
  setFormError,
  formError
}: ChildFormProps) => {
  const params = useParams();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const careplanConfig: any = useAppSelector((state) => state.carePlanData.careplanConfig) || {};

  const [intentValues, setIntentValues] = useState<any>([]);

  useEffect(() => {
    if (careplanConfig?.[AppConstants.CAREPLAN_CONFIG_TEMPLATE_INTENT_VALUES]?.length) {
      setIntentValues(careplanConfig?.[AppConstants.CAREPLAN_CONFIG_TEMPLATE_INTENT_VALUES]);
    }
  }, [careplanConfig]);

  const updateFormData = (value: any) => {
    setFormData(value);
  };

  const updateFormError = (value: any) => {
    setFormError(value);
  };

  useEffect(() => {
    try {
      if (!formData?.category?.length && formError?.category?.length) {
        updateFormError({ category: '' });
        return;
      }
      if (formData?.category.length) {
        JSON.parse(formData?.category);
      }
      updateFormError({ category: '' });
    } catch (e: any) {
      if (formData?.category?.length) {
        updateFormError({ category: e?.message || t('T_ERROR_JSON') });
      }
    }
  }, [formData?.category]);

  useEffect(() => {
    try {
      if (!formData?.identifier?.length && formError?.identifier?.length) {
        updateFormError({ identifier: '' });
        return;
      }
      if (formData?.identifier.length) {
        JSON.parse(formData?.identifier);
      }
      updateFormError({ identifier: '' });
    } catch (e: any) {
      if (formData?.identifier?.length) {
        updateFormError({ identifier: e?.message || t('T_ERROR_JSON') });
      }
    }
  }, [formData?.identifier]);

  useEffect(() => {
    if (formData?.intent.length) {
      let index = findIndex(intentValues, {
        key: formData?.intent?.[0]?.key
      });

      if (index == -1) {
        setIntentValues([...intentValues, ...formData?.intent]);
      }
    }
  }, [formData?.intent, intentValues]);

  return (
    // <div className="h-[75vh] overflow-hidden p-4">
    <div>
      <Card
        title={t('T_CARE_PLAN_DETAILS')}
        icon={Clipboard}
        alt={t('T_CARD_ALT_MESSAGE')}
        height=""
        width=""
      >
        <div className="flex w-full flex-wrap">
          <div className="mb-5 flex w-full">
            <div className="flex w-1/2 flex-col">
              <InputField
                type={'text'}
                id={'careplanTitle'}
                label={t('T_TITLE')}
                placeholder={''}
                fieldKey={'title'}
                asterixFirst={true}
                required={true}
                formData={formData}
                setFormData={updateFormData}
                formError={formError}
                disabled={!isEdit}
                max={AppConstants.MAX_LENGTH_IMPORT_NAME}
              />
            </div>
            <div className="w-1/2 pl-5">
              <PickList
                fieldKey={'key'}
                fieldValues={['display']}
                label={t('T_CARE_PLAN_INTENT')}
                selectedItems={formData.intent}
                showAddOption={false}
                onSelectedChange={(item: any) => {
                  updateFormData({ intent: item });
                }}
                items={intentValues}
                disabled={!isEdit}
                readOnly={false}
                type={PICKLIST_TYPES.SINGLE}
              />
            </div>
          </div>

          <div className="mb-5 flex w-full flex-col">
            <TextAreaField
              fieldKey={'description'}
              type={'text'}
              id={'description'}
              label={t('T_DESCRIPTION')}
              placeholder={''}
              required
              formData={formData}
              setFormData={updateFormData}
              formError={formError}
              asterixFirst
              rows={3}
              disabled={!isEdit}
            ></TextAreaField>
          </div>
          <div className="flex w-full flex-wrap">
            <div className="mb-4 flex w-full">
              <div className="flex w-full flex-col ">
                <JSONEditor
                  setIsLoading={() => {}}
                  isComponent={true}
                  jsonString={formData['category']}
                  setJsonString={(json: any) => {
                    updateFormData({ category: json });
                  }}
                  disabled={!isEdit}
                  showLineNumber={true}
                  showFormatJSONButton={true}
                  showImportJSONButton={false}
                  formatJSONButtonLabel="{}"
                  JSONEditorLabel={t('T_CARE_PLAN_CATEGORY')}
                  height="h-[30vh]"
                />
              </div>
            </div>
          </div>

          <div className="mb-5 flex w-full">
            <div className="flex w-full flex-col ">
              <JSONEditor
                setIsLoading={() => {}}
                isComponent={true}
                jsonString={formData['identifier']}
                setJsonString={(json: any) => {
                  updateFormData({ identifier: json });
                }}
                disabled={!isEdit}
                showLineNumber={true}
                showFormatJSONButton={true}
                showImportJSONButton={false}
                formatJSONButtonLabel="{}"
                JSONEditorLabel={t('T_CARE_PLAN_IDENTIFIER')}
                height="h-[20vh]"
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CarePlanDetails;
